/**
 * Après Purchase — Tab toggle, radio selection, and selling plan logic.
 */
(function () {
  'use strict';

  document.querySelectorAll('[data-apres-purchase]').forEach(function (purchase) {
    var tabs = purchase.querySelectorAll('.apres-purchase__tab');
    var panels = purchase.querySelectorAll('.apres-purchase__panel');
    var ctaText = purchase.querySelector('[data-cta-text]');
    var ctaButton = purchase.querySelector('[data-cta-button]');
    var sellingPlanInput = purchase.closest('section').querySelector('[data-selling-plan-input]');
    var variantInput = purchase.closest('section').querySelector('[data-variant-id-input]');

    function updateSelection(option) {
      /* Swap BOTH the variant id and the selling plan — the Monthly/One-time
         options point at the main tin, the 3-month option points at the
         separate 3-tin product. */
      var planId = option.getAttribute('data-selling-plan') || '';
      if (sellingPlanInput) sellingPlanInput.value = planId;

      var variantId = option.getAttribute('data-variant-id') || '';
      if (variantInput) variantInput.value = variantId;

      if (ctaText) {
        ctaText.textContent = option.getAttribute('data-label') || '';
      }

      /* Disable checkout if the option has no purchasable variant
         (e.g. the 3-tin product hasn't been set in theme settings yet). */
      if (ctaButton) {
        var available = option.getAttribute('data-available') === 'true' && variantId !== '';
        ctaButton.disabled = !available;
      }
    }

    /* ── Tab Toggle ── */
    function activateTab(tab) {
      var target = tab.getAttribute('data-tab');

      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t === tab);
        t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        t.setAttribute('tabindex', t === tab ? '0' : '-1');
      });

      panels.forEach(function (panel) {
        var isTarget = panel.getAttribute('data-panel') === target;
        panel.hidden = !isTarget;
      });

      var activePanel = purchase.querySelector('.apres-purchase__panel:not([hidden])');
      var selectedOption = activePanel
        ? activePanel.querySelector('.apres-purchase__option.is-selected')
        : null;

      if (selectedOption) {
        updateSelection(selectedOption);
      }
    }

    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });

      tab.addEventListener('keydown', function (e) {
        var nextIndex;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          nextIndex = (index + 1) % tabs.length;
          e.preventDefault();
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          nextIndex = (index - 1 + tabs.length) % tabs.length;
          e.preventDefault();
        } else if (e.key === 'Home') {
          nextIndex = 0;
          e.preventDefault();
        } else if (e.key === 'End') {
          nextIndex = tabs.length - 1;
          e.preventDefault();
        }
        if (nextIndex !== undefined) {
          tabs[nextIndex].focus();
          activateTab(tabs[nextIndex]);
        }
      });

      /* Set initial tabindex */
      tab.setAttribute('tabindex', tab.classList.contains('is-active') ? '0' : '-1');
    });

    /* ── Radio Option Selection ── */
    purchase.querySelectorAll('.apres-purchase__option').forEach(function (option) {
      option.addEventListener('click', function () {
        var panel = option.closest('.apres-purchase__panel');
        if (!panel) return;

        panel.querySelectorAll('.apres-purchase__option').forEach(function (opt) {
          opt.classList.remove('is-selected');
        });

        option.classList.add('is-selected');

        updateSelection(option);
      });
    });
  });
})();
